// extracted by mini-css-extract-plugin
export default {"NewContentDialog":"NewContentDialog_NewContentDialog__MI41M"};